import { makeStyles } from '@material-ui/core/styles';
import zIndex from '@material-ui/core/styles/zIndex';

export const useStyles = makeStyles(theme => ({
  container: {
    marginBottom: '26px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '20px',
    },
  },
  wrapper: {
    position: 'relative',
    width: '100%',
    minHeight: '56px',
    [theme.breakpoints.down('sm')]: {
      minHeight: '48px',
    },
  },
  label: {
    display: 'block',
    marginBottom: 6,
    color: '#071B27',
    textTransform: 'uppercase',
    fontSize: 10,
    lineHeight: '12px',
    letterSpacing: '0.035em',
    [theme.breakpoints.down('sm')]: {
      fontSize: 9,
      marginBottom: 5,
    },
  },
  secondLabel: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    marginBottom: '12px',
    color: '#071B27',
    lineHeight: '12px',
    letterSpacing: '0.035em',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '10px',
    },
  },
  datesLabel: {
    display: 'flex',
    textTransform: 'none',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  fromTo: {
    marginRight: '10px',
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      marginRight: '5px'
    },
  },
  customInputDate: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    border: '1px solid #BECEDA',
    borderRadius: '3px',
    boxSizing: 'border-box',
    width: '100%',
    cursor: 'pointer',
    fontSize: '13px',
    lineHeight: '10px',
    padding: '7px 12px',
    position: 'absolute',
    zIndex: '1',
    '&:hover': {
      border: '1px solid #41B7D7',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      padding: '6px 10px',
      width: '100%'
    },
  },
  calendarIcon: {
    fontSize: '20px',
    marginRight: '7px',
    marginTop: '-2px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
      marginRight: '6px',
    },
  },
  dateRangeDivider: {
    margin: '0 3px',
    [theme.breakpoints.down('sm')]: {
      margin: '0 2px',
    },
  },
  hiddenDateRangePicker: {
    position: 'absolute',
    top: '19px',
    left: '0',
    [theme.breakpoints.down('sm')]: {
      top: '17px',
    },
  },
  focus: {
    boxShadow: '0 0 3px 3px rgba(65, 183, 215, 0.35)',
    border: '1px solid #41B7D7',
  },
  errorInput: {
    border: '1px solid #EB5757',
    boxShadow: 'none',
    '&:hover': {
      border: '1px solid #EB5757',
    },
  },
  error: {
    marginTop: '50px',
  },
  errorOpenedPicker: {
    position: 'relative',
    zIndex: 1,
    // margin: '-28px 105px 35px'
  },
  checkboxRoot: {},
  checked: {
    color: '#1D9DC6',
  },
  disabledCheckbox: {
    color: '#BECEDA',
    backgroundColor: '#BECEDA',
  },
  checkboxIcon: {
    color: theme.baseUI.color,
    fontSize: '21px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '19px',
    },
  },

  ClearButton: {
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    marginTop: '-2px',
    fontWeight: 'bold',
    fontSize: '13px',
    textDecoration: 'underline',
    position: 'absolute',
    zIndex: 1,
    right: '0',
    bottom: '0',
    marginRight: '20px',
    marginBottom: '-30px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '11px',
      right: '40px',
       marginRight: '30px',
       marginBottom: '-15px'
    },
  },
  
  dayHalfAvailable: {
    '&:before': {
      content: "''",
      position: 'absolute',
      width: '50%',
      height: '102%',
      top: 0,
      bottom: 0,
      background: '#cacccd',
      zIndex: 1,
    },
    '& > div': {
      zIndex: 2,
      position: 'relative',
    },
  },
  dayLeftDisable: {
    '&:before': {
      left: -1,
      bottom: -1,
    },
  },
  dayRightDisable: {
    '&:before': {
      right: -1,
      bottom: -1,
    },
  },
  
}));



